import { Lock } from "lucide-react";
import PropTypes from "prop-types";

import Modal from "@components/ui-components/modal";
import InputField from "@components/fields/input-field";
import SelectField from "@components/fields/select-field";
import LoadingButton from "@components/ui-components/loading-button";
import { FREQUENCY_OPTIONS, PAYMENT_MODEL_LABEL, PAYMENT_SETUP_STATUS_OPTIONS } from "@constants/panel/common";

const PaymentSetupModal = ({ setup, brand }) => {
    const { open, closeEditor, methods, onSubmit, loading, canSave, showDebitNoteFrequency } = setup;
    const { control, formState: { errors } } = methods;

    return (
        <Modal
            open={open}
            onClose={closeEditor}
            width="md"
            title="Edit payment setup"
            subtitle={`Only the fields you change are updated for ${brand?.name || "this brand"}.`}
            footer={(
                <>
                    <button
                        type="button"
                        onClick={closeEditor}
                        className="rounded-lg border border-gray-300 px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50">
                        Cancel
                    </button>
                    <LoadingButton
                        type="button"
                        onClick={onSubmit}
                        disabled={!canSave}
                        loading={loading}
                        loadingText="Saving…"
                        text="Save changes" />
                </>
            )}>
            {/* Shown for context only — the model is fixed once the brand has picked it. */}
            <div className="mb-4 flex items-center justify-between rounded-lg border border-gray-200 bg-light/60 px-3 py-2.5 text-sm">
                <span className="text-muted">Payment model</span>
                <span className="inline-flex items-center gap-1.5 font-medium text-gray-900">
                    <Lock className="h-3.5 w-3.5 text-muted" />
                    {PAYMENT_MODEL_LABEL[brand?.payment_model] || brand?.payment_model || "—"}
                </span>
            </div>

            <form onSubmit={onSubmit} className="grid gap-x-4 sm:grid-cols-2">
                {showDebitNoteFrequency && (
                    <SelectField
                        control={control}
                        name="debit_note_frequency"
                        label="Debit note frequency"
                        options={FREQUENCY_OPTIONS}
                        placeholder="Select a frequency"
                        errors={errors} />
                )}

                <InputField
                    control={control}
                    name="kyc_window"
                    id="payment-setup-kyc-window"
                    type="number"
                    label="KYC window (days)"
                    errors={errors} />

                <SelectField
                    control={control}
                    name="payment_setup_status"
                    label="Setup status"
                    options={PAYMENT_SETUP_STATUS_OPTIONS}
                    placeholder="Select a status"
                    errors={errors} />
            </form>
        </Modal>
    );
};

PaymentSetupModal.propTypes = {
    setup: PropTypes.object.isRequired,
    brand: PropTypes.object
};

export default PaymentSetupModal;
